import db from '../database/db';
const fetchAndStoreCRData = async (data, customerId, isFullSync = true, pageUrl = '') => {
  try {
    const startTime = performance.now();
    let finalData = data;
    const customerStore = await db.createCustomerStore(customerId);
    if (!isFullSync) {
      const pageUrlData = data?.filter((item) => item.finalurl === pageUrl);
      const existingRecords = await customerStore.toArray();
      const filteredData = existingRecords?.filter(
        (item) => item?.finalurl?.toLowerCase() !== pageUrlData[0]?.finalurl?.toLowerCase()
      );
      finalData = [...filteredData, ...pageUrlData];
    }
    await db.transaction('rw', customerStore, async () => {
      await customerStore.clear();
      await insertDataInBatches(finalData, customerStore, 5000); // 5000 is the maxBatchSize
    });
    const endTime = performance.now();
    const duration = (endTime - startTime) / 1000;
    console.log('endTime Indexed DB', duration);
    return finalData;
  } catch (error) {
    console.error('Error fetching and storing data:', error);
  }
};

const insertDataInBatches = async (data, customerStore, batchSize) => {
  for (let i = 0; i < data.length; i += batchSize) {
    const batch = data.slice(i, i + batchSize);
    await customerStore.bulkPut(batch);
  }
};

export default fetchAndStoreCRData;
